import { Box, LinearProgress, Typography } from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import { KeyboardDatePicker } from "@material-ui/pickers";
import { removeAccents } from "constants/config";
import SearchBar from "material-ui-search-bar";
import moment from "moment";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchTestHistory,
  selectLoading,
  selectTestHistory,
} from "../../adminSlice";
import ContentTableTest from "./ContentTableTest/ContentTableTest";
import LoadingComponent from "components/loading/Loading";

const useStyles = makeStyles({
  root: {
    paddingTop: 8,
    position: "relative",
  },
  paper: {
    width: "100%",
  },
  container: {
    // maxHeight: "500px",
  },
  loading: {
    position: "absolute",
    top: -8,
    width: "100%",
  },
  inputSearch: {
    borderRadius: 30,
    marginBottom: 20,
    marginTop: 10,
    padding: "5px 20px",
    "&:focus-within": {
      border: "1px solid #000",
    },
  },
  datePicker: {
    marginLeft: 15,
    "& .MuiOutlinedInput-root": {
      borderRadius: 12,
    },
  },
});

export const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#eaedf4",
    color: theme.palette.common.black,
    borderRight: "1px solid rgba(224, 224, 224, 1)",
  },
  body: {
    fontSize: 14,
    borderRight: "1px solid rgba(224, 224, 224, 1)",
  },
}))(TableCell);

const columns = [
  { id: "id", label: "ID", minWidth: 20, align: "center" },
  { id: "name", label: "Tên trại", minWidth: 100 },
  {
    id: "address",
    label: "Địa chỉ",
    minWidth: 120,
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "province",
    label: "Tỉnh",
    minWidth: 100,
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "type",
    label: "Loại kiểm tra",
    minWidth: 120,
    format: (value) => value.toFixed(2),
    align: "center",
  },

  {
    id: "createTime",
    label: "Ngày tạo",
    minWidth: 100,
    format: (value) => value.toFixed(2),
  },
  {
    id: "sowsNo",
    label: "Heo nái",
    minWidth: 50,
    format: (value) => value.toFixed(2),
  },
  {
    id: "suckling",
    label: "Heo con",
    minWidth: 50,
    format: (value) => value.toFixed(2),
  },
  {
    id: "boars",
    label: "Heo nọc",
    minWidth: 50,
    format: (value) => value.toFixed(2),
  },
  {
    id: "finishingPigs",
    label: "Heo thịt",
    minWidth: 50,
    format: (value) => value.toFixed(2),
  },
  {
    id: "nurseyPigs",
    label: "Heo cai sữa",
    minWidth: 90,
    format: (value) => value.toFixed(2),
  },

  {
    id: "",
    label: "",
    minWidth: 10,
    format: (value) => value.toFixed(2),
  },
];
export default function TestHistory() {
  const classes = useStyles();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const loading = useSelector(selectLoading);
  const [searched, setSearched] = useState("");
  const testHistory = useSelector(selectTestHistory);
  const [rangesTime, setRangesTime] = useState({
    fromDate: moment().subtract(3, "months").startOf("days").toISOString(),
    toDate: moment(new Date()).startOf("days").toISOString(),
  });
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchTestHistory(rangesTime));
  }, [dispatch, rangesTime]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  const cancelSearch = () => {
    setSearched("");
  };

  const filteredRows = testHistory.filter((row) => {
    return removeAccents(row?.farm?.name).includes(searched.toLowerCase());
  });

  const handleFilterFromDate = (e) => {
    setRangesTime((prev) => ({
      ...prev,
      fromDate: moment(e).toISOString(),
    }));
  };
  const handleFilterToDate = (e) => {
    setRangesTime((prev) => ({
      ...prev,
      toDate: moment(e).toISOString(),
    }));
  };

  return (
    <Box className={classes.root}>
      {/* <MuiPickersUtilsProvider utils={DateFnsUtils}> */}
      <KeyboardDatePicker
        views={["year", "month", "date"]}
        autoOk
        strictCompareDates={true}
        className={classes.datePicker}
        disableToolbar
        variant="inline"
        id="to-date"
        label="Từ ngày"
        inputVariant="outlined"
        disableFuture
        format="dd/MM/yyyy"
        value={rangesTime.fromDate}
        onChange={handleFilterFromDate}
        KeyboardButtonProps={{
          "aria-label": "change date",
        }}
      />
      <KeyboardDatePicker
        views={["year", "month", "date"]}
        autoOk
        strictCompareDates={true}
        className={classes.datePicker}
        disableToolbar
        variant="inline"
        id="to-date"
        label="Đến ngày"
        inputVariant="outlined"
        disableFuture
        format="dd/MM/yyyy"
        value={rangesTime.toDate}
        onChange={handleFilterToDate}
        KeyboardButtonProps={{
          "aria-label": "change date",
        }}
      />
      {/* </MuiPickersUtilsProvider> */}
      <SearchBar
        value={searched}
        onChange={(searchVal) => setSearched(searchVal)}
        onCancelSearch={() => cancelSearch()}
        placeholder="Tìm kiếm theo tên trại"
        className={classes.inputSearch}
      />
      {loading ? (
        <LoadingComponent />
      ) : (
        <Paper className={classes.paper}>
          <TableContainer className={classes.container}>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <StyledTableCell
                      key={column.id}
                      style={{ minWidth: column.minWidth }}
                      align={column.align}
                    >
                      {column.label}
                    </StyledTableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredRows.length > 0 ? (
                  filteredRows
                    ?.slice(
                      page * rowsPerPage,
                      page * rowsPerPage + rowsPerPage
                    )
                    ?.map((row) => {
                      return <ContentTableTest row={row} page={page} />;
                    })
                ) : (
                  <TableRow>
                    <TableCell
                      style={{ height: 200 }}
                      align="center"
                      colSpan={12}
                    >
                      <Typography variant="body1" align="center">
                        No data available
                      </Typography>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          {filteredRows.length > 0 && (
            <TablePagination
              rowsPerPageOptions={[25, 50, 100]}
              component="div"
              count={
                filteredRows?.length > 0
                  ? filteredRows?.length
                  : testHistory?.length
              }
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          )}
        </Paper>
      )}
    </Box>
  );
}
